export const STANDARD_USAGE_TYPES = [
  'HOUSING',
  'LEISURE',
  'CARE',
  'EDUCATION_RESEARCH',
  'LABOUR',
  'PRODUCTION_AND_STORAGE',
] as const

export const LANDSCAPE_USAGE_TYPES = [
  'LANDSCAPE_PRIVATE_OPEN_SPACES',
  'LANDSCAPE_NATURAL_CULTURAL_LANDSCAPES',
  'LANDSCAPE_BUILDING_GREENING',
  'LANDSCAPE_PLAY_SPORT_FACILITIES',
  'LANDSCAPE_SPECIAL_FACILITIES_OBJECTS',
  'LANDSCAPE_FACILITY_SPECIFIC_OPEN_SPACES',
  'LANDSCAPE_PUBLIC_OPEN_SPACES',
] as const

export type UsageTypeKey = (typeof STANDARD_USAGE_TYPES)[number] | (typeof LANDSCAPE_USAGE_TYPES)[number]

export function isLandscapeUsageType(value?: string | null): boolean {
  return typeof value === 'string' && LANDSCAPE_USAGE_TYPES.includes(value as (typeof LANDSCAPE_USAGE_TYPES)[number])
}
